
import React, { useState } from 'react';

export default function ParkNewsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const res = await fetch('https://readdy.ai/api/form/d6bo9teqd308q1a09700', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Newsletter subscription failed:', err);
      setStatus('error');
    }
  };

  return (
    <section className="py-16 bg-emerald-50">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-2xl mx-auto mb-4">
          <i className="ri-mail-send-line text-emerald-600 text-2xl"></i>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Parks &amp; Trails Updates</h2>
        <p className="text-gray-500 mb-6">
          Get notified about trail closures, new park openings, seasonal programs, and community events.
        </p>

        {status === 'success' ? (
          <div className="bg-emerald-100 text-emerald-700 px-6 py-4 rounded-xl font-medium">
            <i className="ri-check-line mr-2"></i>You&apos;re subscribed! Watch your inbox for updates.
          </div>
        ) : (
          <form
            id="parks-newsletter-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-5 py-3 rounded-full border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 bg-emerald-500 text-white rounded-full font-semibold text-sm hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-red-500 text-sm mt-3">
            Something went wrong. Please try again.
          </p>
        )}
      </div>
    </section>
  );
}
